import { Route } from '@angular/router';
import { RoleRedirectGuard } from 'app/core/guards/role-redirect.guard';
import { unknownHostGuard } from 'app/core/guards/unknown-host.guard';
import { tenantHostGuard } from 'app/core/guards/tenant-host.guard';
import { adminShellRoutes } from './routing/admin-shell.routes';
import { guestRoutes } from './routing/guest.routes';
import { publicLandingRoutes } from './routing/public-landing.routes';

/**
 * Role-aware landing (RoleRedirectGuard):
 *   pure SUPER_ADMIN → external nera-sa-portal (fe-web has no SA-only
 *     internal pages left)
 *   org admin tier (ORG_OWNER/ORG_OPERATOR) → /overview
 *   PHOTOGRAPHER → /overview
 *   else authenticated → /me
 */
export const appRoutes: Route[] = [
    // PFL-1967: app-level 404 for hostnames TenantContextService can't
    // classify as a known root/tenant host — see unknown-host.guard.ts.
    // Must stay first: canMatch returns `false` for every legitimate host
    // (router just moves on to the routes below, unchanged), and only
    // short-circuits with a redirect UrlTree for an unrecognized one.
    {
        path: '**',
        canMatch: [unknownHostGuard],
        children: [],
    },
    // Tenant host whose org lookup failed (unknown/suspended subdomain) —
    // see tenant-host.guard.ts. Runs after unknownHostGuard: 'unknown' hosts
    // are already redirected, so only 'tenant'-mode hosts reach the async
    // domain-resolution check inside.
    {
        path: '**',
        canMatch: [tenantHostGuard],
        children: [],
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [RoleRedirectGuard],
        children: [],
    },
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        canActivate: [RoleRedirectGuard],
        children: [],
    },
    guestRoutes,
    publicLandingRoutes,
    // PhotoQA (T5.8): single top-level `/photoqa` mount — see
    // `features/photoqa/photoqa.routes.ts` for why this module owns its own
    // guards/layout instead of nesting under `publicLandingRoutes` /
    // `adminShellRoutes` like every other feature.
    {
        path: 'photoqa',
        loadChildren: () => import('app/features/photoqa/photoqa.routes'),
    },
    adminShellRoutes,
    { path: '**', redirectTo: 'errors/not-found' },
];
